<h2 mat-dialog-title>Create New Character</h2>

<mat-dialog-content>
  <div class="sprite-container">
    @if (character.gender && character.allegiance) {
    <app-npc [sprite]="spriteForPlayer()"></app-npc>
    } @if (character.weapons) {
    <app-item [item]="{ name: displayWeapon, mods: {}, uuid: '' }"></app-item>
    }
  </div>

  <table>
    @if (character.name) {
    <tr>
      <td colspan="11">
        You are
        <strong>{{ character.name }}</strong>
        @if (!character.gender && !character.baseclass) {
        <span>...</span>
        } @if (character.gender || character.baseclass) {
        <span class="m-r-5">, the</span>
        } @if (character.baseclass && !character.gender) {
        <span>...</span>
        } @if (character.gender) {
        <span class="m-r-5">{{ character.gender }}</span>
        } @if (character.gender && !character.baseclass) {
        <span>...</span>
        } @if (character.baseclass) {
        <span>{{ character.baseclass || 'Traveller' }}.</span>
        }
      </td>
    </tr>
    } @if (character.allegiance) {
    <tr>
      <td colspan="11">You are with the {{ character.allegiance }}.</td>
    </tr>
    } @if (character.weapons) {
    <tr>
      <td colspan="11">
        You have chosen to specialize in {{ character.weapons }}.
      </td>
    </tr>
    }
    <tr>
      <td colspan="11">Your base stats are as follows:</td>
    </tr>
    <tr class="stat-row">
      <td>
        @for (stat of allStats; track stat) {
        <div class="p-5 bordered" [matTooltip]="stat.tooltip">
          {{ stat.stat | uppercase }}
          <strong>{{ stats[stat.stat] }}</strong>
        </div>
        }
      </td>
    </tr>
  </table>

  <mat-horizontal-stepper [class.disable]="!character.name" [@.disabled]="true">
    <mat-step
      label="Pick a name and sex"
      [color]="character.name && character.gender ? 'primary' : 'warn'"
    >
      <div class="content-container">
        <div class="m-t-10 text-center">
          <h2>Name</h2>
          <mat-form-field class="full-width">
            <input
              class="input"
              matInput
              type="text"
              autocomplete="off"
              [(ngModel)]="character.name"
              [ngModelOptions]="{ standalone: true }"
              (keyup)="validateName()"
              placeholder="Character name here, all letters, one word, no numbers"
            />
          </mat-form-field>
        </div>

        <div class="m-t-10 text-center">
          <h2>Sex</h2>
          <mat-button-toggle-group [(ngModel)]="character.gender">
            <mat-button-toggle value="male">Male</mat-button-toggle>
            <mat-button-toggle value="female">Female</mat-button-toggle>
          </mat-button-toggle-group>
        </div>
      </div>
    </mat-step>

    <mat-step
      label="Pick a class"
      [color]="character.baseclass ? 'primary' : 'warn'"
    >
      <div class="content-container">
        <div class="text-center">
          <mat-button-toggle-group [(ngModel)]="character.baseclass">
            @for (baseclass of data.charCreateData.classes; track baseclass) {
            <mat-button-toggle
              [value]="baseclass.name"
              (click)="chooseBaseClass(baseclass)"
            >
              {{ baseclass.name }}
            </mat-button-toggle>
            }
          </mat-button-toggle-group>
        </div>

        <div
          class="text-center desc-area"
          [innerHTML]="descs.baseclass || 'Choose a class!'"
        ></div>

        @if ((statMods.baseclass | keyvalue).length > 0) {
        <div class="text-center stat-area">
          <div class="text">Your stats change as follows:</div>
          <div class="stats">
            @for (stat of allStats; track stat) {
            <div
              class="stat"
              class="m-5 p-5 bordered"
              [class.hidden]="!statMods.baseclass[stat.stat]"
            >
              {{ stat.stat | uppercase }}
              <strong>
                {{ statMods.baseclass[stat.stat] > 0 ? '+' : ''
                }}{{ statMods.baseclass[stat.stat] || 0 }}
              </strong>
            </div>
            }
          </div>
        </div>
        }
      </div>
    </mat-step>

    <mat-step
      label="Pick an allegiance"
      [color]="character.allegiance ? 'primary' : 'warn'"
    >
      <div class="content-container">
        <div class="text-center">
          <mat-button-toggle-group [(ngModel)]="character.allegiance">
            @for (allegiance of data.charCreateData.allegiances; track
            allegiance) {
            <mat-button-toggle
              [value]="allegiance.name"
              (click)="chooseAllegiance(allegiance)"
            >
              {{ allegiance.name }}
            </mat-button-toggle>
            }
          </mat-button-toggle-group>
        </div>

        <div
          class="text-center desc-area"
          [innerHTML]="descs.allegiance || 'Choose an allegiance!'"
        ></div>

        @if ((statMods.allegiance | keyvalue).length > 0) {
        <div class="text-center stat-area">
          <div class="text">Your stats change as follows:</div>
          <div class="stats">
            @for (stat of allStats; track stat) {
            <div
              class="stat"
              class="m-5 p-5 bordered"
              [class.hidden]="!statMods.allegiance[stat.stat]"
            >
              {{ stat.stat | uppercase }}
              <strong>
                {{ statMods.allegiance[stat.stat] > 0 ? '+' : ''
                }}{{ statMods.allegiance[stat.stat] || 0 }}
              </strong>
            </div>
            }
          </div>
        </div>
        }
      </div>
    </mat-step>

    <mat-step
      label="Pick a specialization"
      [color]="character.weapons ? 'primary' : 'warn'"
    >
      <div class="content-container">
        <div class="text-center">
          <mat-button-toggle-group [(ngModel)]="character.weapons">
            @for (weapon of data.charCreateData.weapons; track weapon) {
            <mat-button-toggle
              [value]="weapon.name"
              (click)="chooseWeapons(weapon)"
            >
              {{ weapon.name }}
            </mat-button-toggle>
            }
          </mat-button-toggle-group>
        </div>

        <div
          class="text-center desc-area"
          [innerHTML]="descs.weapon || 'Choose a specialization!'"
        ></div>
      </div>
    </mat-step>
  </mat-horizontal-stepper>
</mat-dialog-content>

<mat-dialog-actions>
  <button mat-button mat-dialog-close>Cancel</button>

  <div>
    @if (data.needsOverwrite) {
    <mat-checkbox class="m-r-20" [(ngModel)]="overwriteChecked">
      Overwrite My Existing Character
    </mat-checkbox>
    }
    <button
      mat-button
      mat-dialog-close
      color="primary"
      [disabled]="!canCreateCharacter"
      (click)="create()"
    >
      Create!
    </button>
  </div>
</mat-dialog-actions>
